import dateFormat, { masks } from "dateformat";
import React, { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import CustomerActivityComment from "../Customer/CustomerActivityComment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import ForumIcon from "@mui/icons-material/Forum";
import { api_path } from "../../shared.js";
function SalesActitivityDetail(props) {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = `${api_path}/customer/customer_activities.php?SALES_ACTIVITY_ID=${props.SALES_ACTIVITY_ID}&CRM_CUSCODE=${props.CRM_CUSCODE}`;
  const [getData, setData] = useState([]);
  const showCostData = true;
  useEffect(() => {
    //run when id Change value.
    if (props.SALES_ACTIVITY_ID > 0) {
      fetchItemData();
    } else {
    }
  }, [props.CRM_CUSCODE]);
  const fetchItemData = async () => {
    const response = await fetch(
      api_path +
        "/customer/customer_activities.php?SALES_ACTIVITY_ID=" +
        props.SALES_ACTIVITY_ID +
        "&CRM_CUSCODE=" +
        props.CRM_CUSCODE
    );
    const data = await response.json();
    setData(data);
  };
  const validCellRender = (data) => {
    let color = "";
    switch (data.value) {
      case "Valid":
        color = "#c8e6c9"; // เขียวอ่อน
        break;
      case "Duplicate":
        color = "#ffcdd2"; // แดงอ่อน
        break;
      case "Unclear":
        color = "#fff9c4"; // เหลืองอ่อน
        break;
      default:
        color = "#eeeeee";
    }

    return (
      <div
        style={{ backgroundColor: color, padding: "4px", borderRadius: "4px" }}
      >
        {data.value}
      </div>
    );
  };
  if (getData.length > 0) {
    return (
      <div className="">
        <div className="timeline-item-v2-component">
          {showCostData ? (
            <>
              {getData.map((fdata) => {
                return (
                  <div className="timeline-item-v2-component-box">
                    <div className="timeline-item-event-header-wrapper">
                      <div class="icon-thumbnail-component timeline-item-icon">
                        <CalendarMonthIcon />
                      </div>
                      <div class="timeline-item-date-wrapper">
                        <div className="timeline-date-v2-component">
                          {dateFormat(
                            fdata.ACTIVITY_DATE,
                            "dd-mmm-yyyy H:mm:ss"
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="timeline-item-content-wrapper2">
                      <div className="timeline-item-header-title">
                        <span 
                          className={`status-button activity-badge activity-${fdata.ACTIVITY_NAME.toLowerCase().replace(
                            /\s/g,
                          "-"
                          )}`}
                        >
                          
                          {fdata.ACTIVITY_NAME}
                        </span>

                        <p>
                          {" "}
                          <b>{fdata.TOPIC}</b>
                        </p>
                        <p className="wraptext">{fdata.DESCRIPTION}</p>
                        <b>By: {fdata.CREATE_BY}</b>
                      </div>
                      <CustomerActivityComment
                        CRM_CUSCODE={fdata.CRM_CUSCODE}
                        SALES_ACTIVITY_ID={fdata.SALES_ACTIVITY_ID}
                        FROM="ACTIVITY"
                      />
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <p>You cannot see the data</p>
          )}
        </div>
      </div>
    );
  } else {
  }
}

export default SalesActitivityDetail;
